import { render, staticRenderFns } from "./BeaconBattery.vue?vue&type=template&id=6a50ad87&scoped=true&"
import script from "./BeaconBattery.vue?vue&type=script&lang=js&"
export * from "./BeaconBattery.vue?vue&type=script&lang=js&"
import style0 from "./BeaconBattery.vue?vue&type=style&index=0&id=6a50ad87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a50ad87",
  null
  
)

export default component.exports